import React, {useEffect, useRef} from "react";
import css from './guessYouLike.module.scss'
import classNames from "classnames";
import {observer} from "mobx-react";
import Swiper from "swiper";
import showPrice from "../../utils/ShowPrice";
import GoodsType from "../../enum/GoodsType";
import {useHistory} from "react-router-dom";
import MyRouterUtil from "../../utils/MyRouterUtil";

const Index = ({className, goodsList = []}) => {
    const history = useHistory()

    const swiperRef = useRef()
    useEffect(() => {
        if (!(swiperRef.current && goodsList.length)) {
            return;
        }

        const mySwiper = new Swiper(swiperRef.current, {
            slidesPerView: "auto",
            spaceBetween: 12,
            // autoplay: {
            //     delay: 2500,
            //     disableOnInteraction: false,
            // },
        })

        //鼠标覆盖停止自动切换
        swiperRef.current.onmouseover = function () {
            mySwiper.autoplay.stop();
        }

        //鼠标离开开始自动切换
        swiperRef.current.onmouseout = function () {
            mySwiper.autoplay.start();
        }
    }, [swiperRef.current, goodsList.length]);

    // 商品详情
    const toGoodsInfo = ({goodsType, id}) => {
        MyRouterUtil.build({history}).toGoodsInfo({goodsType, id})
        console.log(`goodsType:${goodsType},id:${id}`)
    }

    return (
        <div className={classNames(className, css.root)}>
            <div className={css.container}>
                <div className={classNames('swiper', css.swiper)} ref={swiperRef}>
                    <div className={classNames('swiper-wrapper', css.swiperWrapper)}>
                        {
                            goodsList.map(item => {
                                const {id, mainPic, name, originPrice, currentPrice, isHot, isPddShop, isJdShop} = item;
                                const isSelf = !isPddShop && !isJdShop

                                let goodsType;
                                if (isPddShop) {
                                    goodsType = GoodsType.PDD
                                } else if (isJdShop) {
                                    goodsType = GoodsType.JD
                                } else {
                                    goodsType = GoodsType.SELF
                                }
                                return (
                                    <div
                                        key={id}
                                        className={classNames('swiper-slide', css.swiperSlide)}
                                    >
                                        <div className={css.left}>
                                            <div className={css.imgWrapper}>
                                                <img src={mainPic} alt=""/>
                                            </div>
                                        </div>
                                        <div className={css.right}>
                                            <div className={css.name}>
                                                {isSelf && <span className={css.self}>自营</span>}
                                                {isPddShop && <span className={css.pdd}>拼多多</span>}
                                                {isJdShop && <span className={css.jd}>京东</span>}
                                                {name}
                                            </div>
                                            <div className={css.priceFloor}>
                                                <div className={css.price}>
                                                    {showPrice(currentPrice)}
                                                </div>
                                                <div className={css.oldPrice}>
                                                    {showPrice(originPrice)}
                                                </div>
                                            </div>
                                            <div className={css.btnFloor}>
                                                {
                                                    !!isHot &&
                                                    <div className={css.isHotWrapper}>
                                                        <div className={css.isHot}>热销商品</div>
                                                    </div>
                                                }
                                                <button
                                                    className={css.btnToGoodsInfo}
                                                    onClick={() => toGoodsInfo({goodsType, id})}
                                                >
                                                    查看详情
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(Index)